import IntlCurrencyInput from 'components/inputCurrency';
import { MaskedInput } from 'components/Inputs/MaskedInput';
import { SelectInput } from 'components/Inputs/SelectInput';
import { TextInput } from 'components/Inputs/TextInput';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CompanyContractTypeEnum, ICompanyCreate } from 'types/Company';

import { Divider, Grid, MenuItem, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { AccessForm } from './AccessForm';
import { CompanyAddressForm } from './AddressForm';

export const CompanyForm: React.FC = () => {
  const { setValue, watch } = useFormContext<ICompanyCreate>();
  const companyId = watch('id');

  return (
    <>
      <Box p={2}>
        <Typography sx={{ fontSize: 20, fontWeight: 500 }}>
          Dados da Empresa
        </Typography>

        <Grid item container spacing={2} mt={1}>
          <Grid item xs={12} md={3}>
            <SelectInput
              name="contractType"
              id="contractType"
              label="TIPO DE CONTRATAÇÃO"
              required={true}
            >
              {Object.entries(CompanyContractTypeEnum).map(([value, title]) => (
                <MenuItem key={value} value={value}>
                  {title}
                </MenuItem>
              ))}
            </SelectInput>
          </Grid>

          <Grid item xs={12} md={3}>
            <MaskedInput
              name="cnpj"
              id="cnpj"
              label="CNPJ"
              placeholder="__.___.___/____-__"
              mask="##.###.###/####-##"
              required={true}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextInput
              name="socialReason"
              id="socialReason"
              label="RAZÃO SOCIAL"
              required={true}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextInput
              required
              name="planPrice"
              id="planPrice"
              defaultValue={Number('0,00')}
              label="VALOR DO PLANO"
              InputProps={{
                inputComponent: IntlCurrencyInput as any,
              }}
              //@ts-ignore
              onChange={(_, value) => {
                setValue('planPrice', value, {
                  shouldValidate: true,
                });
              }}
              InputLabelProps={{ shrink: true }}
              disabled={Boolean(companyId)} // Disable if company will be updated
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <MaskedInput
              name="phone"
              id="phone"
              label="TELEFONE FIXO"
              mask="(##) ####-####"
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <MaskedInput
              name="mobilePhone"
              id="mobilePhone"
              label="TELEFONE CELULAR"
              mask="(##) #####-####"
            />
          </Grid>

          <CompanyAddressForm />
        </Grid>

        <Divider sx={{ mt: 4, mb: 3 }} />

        <AccessForm />
      </Box>
    </>
  );
};
